import PastEvent from "../../components/PastEvents";
import Trending from "../../components/Trending";
import Offers from "../../components/Offers";
import { ToastContainer } from "react-toastify";
import HeroBanner from "../../components/HeroBanner";

type Props = {};

const Home = (props: Props) => {
  return (
    <>
      <div className="">
        <HeroBanner />
        <Trending />

        <PastEvent />
        <Offers />
        <ToastContainer />
      </div>
    </>
  );
};

export default Home;
